export function feedbackHref(params = {}) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== "" && v !== false) q.set(k, v); });
  const s = q.toString();
  return `/app/feedback${s ? `?${s}` : ""}`;
}

export const FILTER_LABELS = {
  location_id: "Location", employee_id: "Employee", days: "Last days", rating: "Stars", question: "Question",
  answer: "Answer", dimension: "Detail", dim_value: "Detail score", problem_category: "What went wrong",
  source: "Channel", resolved: "Resolved at the time", has_comment: "With comment", theme: "Theme",
  touchpoint: "Service moment", review_status: "Trust status", point_id: "Counter/table",
  low_dim: "Low detail",
};
